// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ot3n","content":"styles_content__2SWXO"};